import {IColumnItem} from "@ui/tableCustom/types/columns";

export const getExportStylesFromColumnCb = <T>(column: IColumnItem<T>) => {
    return column?.exportStyles?.excel;
}
